import { get } from 'lodash'
import {
  FETCH_LABELS_DATA,
  RECEIVE_LABELS_DATA,
  LABELS_DATA_ERROR
} from '../actions/labelsData'
import { formatTerms, formatCode } from '../utils/formatTerms'
import { getIsActivePackageBundled } from './activePackage'

const initialState = {
  isLoading: false,
  hasError: false,
  labels: null
}

const labelsData = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LABELS_DATA:
      return Object.assign({}, state, {
        isLoading: true
      })
    case RECEIVE_LABELS_DATA: {
      return Object.assign({}, state, {
        isLoading: false,
        labels: action.payload
      })
    }
    case LABELS_DATA_ERROR: {
      return Object.assign({}, state, {
        isLoading: false,
        hasError: true
      })
    }
    default:
      return state
  }
}

export const getTermsByCurrency = state => {
  const currency = get(state, 'activeSearchParameters.currency', 'USD')
  const labels = get(state, 'labelsData.labels', null)
  const isBundlePricing = getIsActivePackageBundled(state)

  if (!currency || !labels) return null

  const currencyTerms = get(labels, [`${currency.toLowerCase()}-terms`])
  const result = currencyTerms ? currencyTerms : get(labels, 'int-terms')

  if (currency !== 'USD' && result && result.terms_content) {
    return {
      ...result,
      terms_content: formatCode(result.terms_content, currency)
    }
  }

  if (isBundlePricing && result && result.terms_content) {
    return {
      ...result,
      terms_content: formatTerms(result.terms_content)
    }
  }

  return result
}

export default labelsData
